import { Moment } from 'moment';

export class TimeListItem {
    public time: string;
    public date: Date;
    public disabled: boolean;
    public selected: boolean;
    public outsideRange: boolean;
    public index?: number;
    public moment: Moment;

    constructor(momentObj: Moment, time?: string, date?: Date, outsideRange?: boolean, index?: number) {
        this.time = time;
        this.date = date || momentObj.toDate();
        this.outsideRange = outsideRange || false;

        if (index >= 0) {
            this.index = index;
        }

        this.moment = momentObj;
    }
}